import React, { useEffect, useState } from 'react';
import gifPortada from '../assets/ecosistema_1920x1080.gif';

const Portada = () => {
  const [hiddenClass, setHiddenClass] = useState('');
  let hasEventFired = false;

  useEffect(() => {
    // Amagar la portada al fer scroll
    window.addEventListener('scroll', () => {
      if (!hasEventFired) {
        setHiddenClass('block-portada__hidden');
        hasEventFired = true;
      }
    });

    // Amagar la portada després de 8 segons
    setTimeout(() => {
      setHiddenClass('block-portada__hidden');
    }, 8000);
  });

  return (
    <section className={`block block-portada ${hiddenClass}`}>
      <img src={gifPortada} alt="Presentació SARRIÀ:ECOSISTEMA" />
    </section>
  );
};

export default Portada;
